import React from "react";
import useLanguage from "../../../../utilities/useLanguage";
import { getTranslation } from "../../translations";

export default (props) =>{
    const { lang } = useLanguage();
    const {show,details} = props;
    if(show && !details){
        return (
            <div className="col-12 text-center p-5">  
                <h4>{getTranslation(lang).onlineQuoteNotFound}</h4>
            </div>
        );
    }
    return null;
};

